import React from 'react';

export const BadrinathSilhouette: React.FC<{ w?: number; h?: number }> = ({ w = 120, h = 130 }) => {
  return (
    <svg viewBox="0 0 200 220" width={w} height={h} xmlns="http://www.w3.org/2000/svg">
      {/* Background Spire */}
      <polygon points="50,150 100,50 150,150" fill="rgba(255,215,0,0.2)" />
      <polygon points="70,150 100,65 130,150" fill="rgba(255,215,0,0.3)" />

      {/* Main Top Canopy (Curved) */}
      <path d="M 40,90 Q 100,60 160,90 L 155,120 L 45,120 Z" fill="rgba(255,215,0,0.6)" />

      {/* Motif boxes */}
      <rect x="52" y="88" width="24" height="26" fill="rgba(255,215,0,0.4)" rx="4" />
      <rect x="85" y="80" width="30" height="30" fill="rgba(255,215,0,0.8)" rx="4" />
      <rect x="124" y="88" width="24" height="26" fill="rgba(255,215,0,0.4)" rx="4" />
      <circle cx="100" cy="95" r="8" fill="rgba(0,0,0,0.3)" />

      {/* Golden Finials (Kalashas) */}
      <polygon points="62,85 64,65 66,85" fill="rgba(255,215,0,0.8)" />
      <circle cx="64" cy="65" r="3" fill="rgba(255,215,0,0.9)" />

      <polygon points="98,75 100,50 102,75" fill="rgba(255,215,0,0.8)" />
      <circle cx="100" cy="50" r="4" fill="rgba(255,215,0,0.9)" />

      <polygon points="134,85 136,65 138,85" fill="rgba(255,215,0,0.8)" />
      <circle cx="136" cy="65" r="3" fill="rgba(255,215,0,0.9)" />

      {/* Flag and Mast */}
      <rect x="99" y="10" width="2" height="40" fill="rgba(255,215,0,0.8)" />
      <path d="M 101,12 Q 130,8 145,15 Q 130,22 140,28 L 101,30 Z" fill="rgba(255,215,0,0.7)" />

      {/* Main Facade Base */}
      <rect x="45" y="120" width="110" height="80" fill="rgba(255,215,0,0.5)" />
      <rect x="42" y="116" width="116" height="4" fill="rgba(255,215,0,0.9)" />

      {/* Entrance Mandapa Arch */}
      <path d="M 65,200 L 65,150 Q 100,115 135,150 L 135,200 Z" fill="rgba(255,215,0,0.7)" />
      <path d="M 72,200 L 72,155 Q 100,125 128,155 L 128,200 Z" fill="rgba(255,215,0,0.9)" />
      <path d="M 80,200 L 80,162 Q 100,138 120,162 L 120,200 Z" fill="rgba(0,0,0,0.3)" />

      {/* Left Wing */}
      <rect x="5" y="125" width="40" height="8" fill="rgba(255,215,0,0.6)" />
      <rect x="5" y="133" width="40" height="67" fill="rgba(255,215,0,0.4)" />
      <rect x="10" y="145" width="10" height="45" fill="rgba(0,0,0,0.3)" />
      <rect x="28" y="145" width="10" height="45" fill="rgba(0,0,0,0.3)" />

      {/* Right Wing */}
      <rect x="155" y="125" width="40" height="8" fill="rgba(255,215,0,0.6)" />
      <rect x="155" y="133" width="40" height="67" fill="rgba(255,215,0,0.4)" />
      <rect x="162" y="145" width="10" height="45" fill="rgba(0,0,0,0.3)" />
      <rect x="180" y="145" width="10" height="45" fill="rgba(0,0,0,0.3)" />

      {/* Base Steps */}
      <rect x="0" y="200" width="200" height="10" fill="rgba(255,215,0,0.3)" />
      <rect x="20" y="210" width="160" height="10" fill="rgba(255,215,0,0.2)" />
    </svg>
  );
};
;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
